export const TEXT = 'TEXT' as const;
export const ASSIGNEE = 'ASSIGNEE' as const;
export const LABEL = 'LABEL' as const;
export const ISSUE_PARENT = 'ISSUE_PARENT' as const;
export const VERSION = 'VERSION' as const;
export const ISSUE_TYPE = 'ISSUE_TYPE' as const;
export const CUSTOM_FILTER = 'CUSTOM_FILTER' as const;
export const JQL = 'JQL' as const;

export const MAX_AVATARS = 6;
